module.exports = "\n.modal-content .form-group{\n    padding-bottom: 25px!important;\n}\n.modal-content .form-group:last-child{\n    padding-bottom: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/track-trace/shared-components/modal-event/modal-event.component.css
// module id = ./src/app/component/track-trace/shared-components/modal-event/modal-event.component.css
// module chunks = main